module.exports = __webpack_public_path__ + "img/tuoy.2ac23146.png";